/**
 * Журнал консоли записи бага (.txt) — разбор для просмотра в карточке.
 *
 * Файл пишет NetworkLog.consoleText: шапка, пустая строка и записи вида
 * «[мм:сс.ммм] LEVEL текст  (адрес:строка)». Текст бывает многострочным
 * (стек исключения): строки без метки времени — продолжение предыдущей
 * записи. Файл остаётся текстом, чтобы его можно было прочитать и
 * скачанным, без «Задачника».
 */

export interface ConsoleRecord {
  /** «мм:сс.ммм» от начала записи. */
  time: string;
  level: string;
  text: string;
  source: string | null;
}

export interface ConsoleLog {
  header: string[];
  records: ConsoleRecord[];
}

const RECORD = /^\[(\d{2,}:\d{2}\.\d{3})\] (\S+) +(.*)$/;
/** Источник — в конце последней строки записи, через два пробела. */
const SOURCE = / {2}\(([^()\n]+)\)$/;

export function isErrorLevel(level: string): boolean {
  return level === "error";
}

/** Разбор файла; null — это не журнал консоли записи бага. */
export function parseConsoleLog(text: string): ConsoleLog | null {
  const lines = text.replace(/\r\n/g, "\n").split("\n");
  const blank = lines.indexOf("");
  if (blank <= 0) return null;
  const header = lines.slice(0, blank);
  const records: ConsoleRecord[] = [];
  const open: { time: string; level: string; lines: string[] }[] = [];

  for (const line of lines.slice(blank + 1)) {
    const match = RECORD.exec(line);
    if (match !== null) {
      open.push({ time: match[1] ?? "", level: (match[2] ?? "").toLowerCase(), lines: [match[3] ?? ""] });
    } else if (open.length > 0) {
      open.at(-1)?.lines.push(line);
    }
  }
  for (const record of open) {
    // Хвостовые пустые строки — конец файла, а не часть сообщения.
    while (record.lines.length > 1 && record.lines.at(-1) === "") record.lines.pop();
    const body = record.lines.join("\n");
    const source = SOURCE.exec(body);
    records.push({
      time: record.time,
      level: record.level,
      text: source === null ? body : body.slice(0, source.index),
      source: source?.[1] ?? null,
    });
  }
  return { header, records };
}
